import { lzSAtomWithLocalStorage } from '@lz-store/services';
import LzMConfigurations from '@lz-models/commons/Configurations';

const lzSAuthAppConfigsAtom = lzSAtomWithLocalStorage<LzMConfigurations | null>('authAppConfigsState', null);

export default lzSAuthAppConfigsAtom;
